import { Injectable } from '@angular/core';
import { AlloxApiService } from './allox-api.service';
import { map } from 'rxjs/operators';
import { AllowedUserEmailDomain } from '../models/allowed-user-email-domain.model';

@Injectable({ providedIn: 'root' })
export class AllowedUserEmailDomainService {

  private path = '/allowed_user_email_domains';

  constructor(private http: AlloxApiService) { }

  public search() {
    return this.http.get<[]>(this.path).pipe(
      map(objs => objs.map(obj => new AllowedUserEmailDomain(obj)))
    );
  }
}
